export enum RealmType {
    TITAN_EXTERNAL = 2,
    TITAN_INTERNAL = 1,
    TITAN_GUEST = 3
}